import React from "react";
import { NavLink } from "react-router-dom";

import * as Config from "../../helper/Configs";

export default function RoomGrid(props) {
	const { room, resort} = props;

	return (
		<>
		{room && resort &&
			<div
				style={{
					backgroundImage: `url(${Config.MEDIA_URL}images/${room.image && room.image.image})`,
					backgroundSize: "cover"
				}}
			>
				<section className={"bg"}>
					<section>
						<NavLink to={`/rooms/${resort.slug}`}> {room.name} </NavLink>
					</section>
				</section>
			</div>
		}
		</>
	);
}
